import { httpManager as http } from '@/plugins/HttpManager';
import { getSetBitValue, hasBitValue } from '@/utils/bit';
import { config } from 'CONFIG';

export const createMFASession = async ( data: { id: string;code: string; }): Promise<any> => {

    return ( await http.post( '/auth/mfa/sessions', data )).data;

};
const createMFACode = async ( method: string, scenario: string, data: { account?: string;emailAddress?: string; }): Promise<any> => {

    return (
        await http.post( '/auth/mfa/codes', {
            clientId: config.clientId,
            scenario,
            method,
            data
        })
    ).data;

};
export const createTOTPMFACode = ( scenario: string, emailAddress: string ): Promise<any> =>
    createMFACode( 'totp', scenario, {
        account: `email:${emailAddress}`
    });
export const createEmailMFACode = ( scenario: string, emailAddress: string ): Promise<any> =>
    createMFACode( 'email', scenario, {
        emailAddress
    });
export const getMFAMethods = async ( scenario: string ): Promise<any> => {

    const res = (
        await http.get(
            `/auth/mfa/methods?scenario=${encodeURIComponent( scenario )}`
        )
    ).data;
    const enabledMethods: any[] = [];
    let context = 0;
    const TOTP_CONTEXT = 0b1;
    const BACKUP_CONTEXT = 0b10;
    const methods = Object.keys( res );
    let backupCodeIndex;
    for ( let i = 0, len = methods.length; i < len; i++ ) {

        const method = methods[i];
        if ( res[method].enabled ) {

            switch ( method ) {

                case 'totp':
                    context = getSetBitValue( context, TOTP_CONTEXT );
                    break;
                case 'backup_code':
                    context = getSetBitValue( context, BACKUP_CONTEXT );
                    backupCodeIndex = i;
                    break;

            }
            enabledMethods.push( method );

        }

    }
    if (
        hasBitValue( context, TOTP_CONTEXT ) &&
        hasBitValue( context, BACKUP_CONTEXT )
    ) {

        enabledMethods.splice( backupCodeIndex, 1 );

    }

    return enabledMethods;

};
